import { Box, SimpleGrid } from "@chakra-ui/react";
import ProjectsTable from "./components/Table";
import { useLaunchedProject } from "./hooks/useLaunchedProject";
import { KanbanBoard } from "./components/KanbanBoard";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import NewTaskForm from "./components/FormTask";

const LauchedProjectScreen = () => {
    const { state,
        getTasksList,
        closeKamban,
        changeInput,
        displayInputError,
        setShowTaskForm,
        saveTask,
        changeTaskStatus
    } = useLaunchedProject();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <ConditionalRenderer
                conditions={[
                    {
                        condition: state.loading,
                        component: (
                            <Box>Carregando...</Box>
                        )
                    },
                    {
                        condition: state.tableList.length > 0 && !state.loading && !state.projectSelected,
                        component: (
                            <SimpleGrid
                                mb="20px"
                                columns={{ sm: 1, md: 1 }}
                                spacing={{ base: "20px", xl: "20px" }}
                            >
                                <ProjectsTable
                                    state={state}
                                    getTasksList={getTasksList}
                                />
                            </SimpleGrid>)
                    },
                    {
                        condition: state.projectSelected && !state.loading,
                        component: (
                            <>
                                <NewTaskForm
                                    state={state}
                                    closeKamban={closeKamban}
                                    changeInput={changeInput}
                                    displayInputError={displayInputError}
                                    saveTask={saveTask}
                                    setShowTaskForm={setShowTaskForm}
                                />
                                <KanbanBoard
                                    state={state}
                                    setShowTaskForm={setShowTaskForm}
                                    changeTaskStatus={changeTaskStatus}
                                />
                            </>
                        )
                    }
                ]}
                fallback={(
                    <Box>Nenhum projeto encontrado</Box>
                )}
            />
        </Box>
    )
}
export default LauchedProjectScreen;